import { TransparentButton, Typography } from '@libs/components';
import { hexColorWithOpacity } from '@libs/helpers';
import styled, { css } from 'styled-components';

export const ChartWrapper = styled.div`
  display: flex;
  width: 100%;
`;
export const ColumnChartWrapper = styled.div`
  height: 30rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

export const ZeroAxis = styled.div`
  position: absolute;
  top: 50%;
  bottom: 50%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  border-bottom: 1px dotted ${({ theme }) => theme.colors.text.success};
  gap: 0.5rem;
  z-index: ${({ theme }) => theme.zIndex.medium};
`;

type ColumnProps = {
  isNegative?: boolean;
  height: number;
  isAmountZero?: boolean;
  isActive?: boolean;
};
export const Column = styled(TransparentButton)<ColumnProps>`
  flex: 1;

  max-width: 9.35rem;
  height: ${({ height }) => `${height / 10 || 0.5}rem`};

  ${({ isNegative, isAmountZero, theme, height, isActive }) => {
    const columnColorOpacity = isActive ? 100 : 50;

    if (isAmountZero) {
      return css`
        border-top-left-radius: ${theme.borderRadius.x1};
        border-top-right-radius: ${theme.borderRadius.x1};
        background-color: ${hexColorWithOpacity(
          theme.colors.borders.default,
          columnColorOpacity
        )};
      `;
    } else if (isNegative) {
      return css`
        border-bottom-left-radius: ${theme.borderRadius.x1};
        border-bottom-right-radius: ${theme.borderRadius.x1};
        background-color: ${hexColorWithOpacity(
          theme.colors.text.critical,
          columnColorOpacity
        )};
        margin-bottom: -${height / 10 + 0.1}rem;
      `;
    } else {
      return css`
        border-top-left-radius: ${theme.borderRadius.x1};
        border-top-right-radius: ${theme.borderRadius.x1};
        background-color: ${hexColorWithOpacity(
          theme.colors.text.success,
          columnColorOpacity
        )}; ;
      `;
    }
  }}
`;

type XAxisLineProps = {
  isVisible?: boolean;
};
export const XAxisLine = styled.div<XAxisLineProps>`
  position: relative;
  width: 100%;
  height: 1px;
  background-color: ${({ theme, isVisible }) =>
    isVisible
      ? hexColorWithOpacity(theme.colors.borders.default, 50)
      : 'transparent'};
`;

export const Relative = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ChartYAxisLabels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 1rem;
  margin-right: 1rem;
`;

export const CustomTypography = styled(Typography)`
  white-space: nowrap;
`;
